import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

import { handleLogout } from '@store/authentication'

export const getAllGroups = createAsyncThunk('group/getAllGroups', async (params, thunkAPI) => {
  try {
    const { limit, offset } = params
    const queryParams = new URLSearchParams()
    
    if (limit) queryParams.append('limit', limit)
    if (offset) queryParams.append('offset', offset)
    
    const queryString = queryParams.toString()
    const url = `/api/groups${queryString ? `?${queryString}` : ''}`
    
    const { data } = await axios.get(url)
    return data
  } catch (error) {
    const { errors } = error.response.data
    return thunkAPI.rejectWithValue({ error: errors.length ? errors[0].message : error.message })
  }
})

export const getStudentGroup = createAsyncThunk('group/getStudentGroup', async (params, thunkAPI) => {
  try {
    const { data } = await axios.get(`api/groups/student-group`, {
      headers: {
        Authorization: params.accessToken
      }
    })

    return data
  } catch (error) {
    const { errors } = error.response.data
    return thunkAPI.rejectWithValue({ error: errors.length ? errors[0].message : error.message })
  }
})

export const getGroupsByLeader = createAsyncThunk('group/getGroupsByLeader', async (params, thunkAPI) => {
  try {
    const { data } = await axios.get(`/api/groups/by-leader/${params.leaderId}`)

    return data
  } catch (error) {
    const { errors } = error.response.data
    return thunkAPI.rejectWithValue({ error: errors.length ? errors[0].message : error.message })
  }
})

export const updateGroup = createAsyncThunk('group/updateGroup', async (params, thunkAPI) => {
  try {
    const { groupId, updateData } = params
    const { data } = await axios.put(`/api/groups/${groupId}`, updateData)

    return data
  } catch (error) {
    const { errors } = error.response.data
    return thunkAPI.rejectWithValue({ error: errors.length ? errors[0].message : error.message })
  }
})

const initialState = {
  studentGroup: null,
  loadingStudentGroup: true,

  groupsByLeader: [],
  isGroupsByLeaderLoading: true,

  allGroups: {
    records: [],
    _metadata: {
      total_count: 0
    }
  },
  isAllGroupsLoading: true,
  isUpdatingGroup: false
}

const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    resetGroupsByLeader: state => {
      state.groupsByLeader = []
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getStudentGroup.fulfilled, (state, action) => {
        state.studentGroup = action.payload
        state.loadingStudentGroup = false
      })
      .addCase(getStudentGroup.rejected, (state, action) => {
        state.studentGroup = action.payload
        state.loadingStudentGroup = false
      })
      .addCase(getGroupsByLeader.fulfilled, (state, action) => {
        action.payload.forEach(result => state.groupsByLeader.push(result))
        state.isGroupsByLeaderLoading = false
      })
      .addCase(getAllGroups.fulfilled, (state, action) => {
        state.allGroups = action.payload
        state.isAllGroupsLoading = false
      })
      .addCase(getAllGroups.rejected, state => {
        state.isAllGroupsLoading = false
      })
      .addCase(updateGroup.pending, state => {
        state.isUpdatingGroup = true
      })
      .addCase(updateGroup.fulfilled, (state, action) => {
        const index = state.groupsByLeader.findIndex(group => group.id === action.payload.id)
        if (index !== -1) {
          state.groupsByLeader[index].threshold = action.payload.threshold
        }
        state.isUpdatingGroup = false
      })
      .addCase(updateGroup.rejected, state => {
        state.isUpdatingGroup = false
      })
      .addCase(handleLogout, () => {
        return initialState
      })
  }
})

export const { resetGroupsByLeader } = groupSlice.actions

export default groupSlice.reducer